import { Text as T } from '@eo-locale/preact';
import { ReviewSource } from 'types/review';

import { useSettings } from 'components/SettingsProvider';
import { Stack } from 'components/Stack';
import { Text } from 'components/Text';
import { Tip } from 'components/Tip';

interface TipWasImportedProps {
  source: ReviewSource;
}

export function TipWasImported({ source }: TipWasImportedProps) {
  const { settings } = useSettings();

  if (source !== 'IMPORT') return null;
  if (settings.reviews.tweaks.hide_was_imported_tooltip) return null;

  return (
    <Tip
      content={
        <Stack vertical>
          <Text size="small">
            <T
              id="review_was_imported_message"
              defaultMessage="This review was imported from an external source."
            />
          </Text>
        </Stack>
      }
    />
  );
}
